const CarList = () => import('Views/car/car-list');
const CarAddEdit = () => import('Views/car/car-addEdit');
const CarDetail = () => import('Views/car/car-detail');

export default[
  { path: '/car-list', component: CarList },
  { path: '/car-add', component: CarAddEdit },
  { path: '/car-edit/:id', component: CarAddEdit },
  { path: '/car-detail/:id', component: CarDetail },
];



// WEBPACK FOOTER //
// ./src/router/car.js